import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import EngineMonitoring from "./pages/EngineMonitoring";
import AlertSystem from "./pages/AlertSystem";
import Ship3DView from "./pages/Ship3DView";
import DataAnalytics from "./pages/DataAnalytics";
import ThreeTest from "./pages/ThreeTest";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/engine-monitoring" element={<EngineMonitoring />} />
          <Route path="/alerts" element={<AlertSystem />} />
          <Route path="/3d-view" element={<Ship3DView />} />
          <Route path="/analytics" element={<DataAnalytics />} />
          <Route path="/three-test" element={<ThreeTest />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
